<table class="w-full h-full">
  <tr class="w-full">
    <td class="flex flex-row gap-2 h-full">

      <div class="label-y">
        @if (labels.y) {
          <h4>{{ labels.y }}</h4>
        }
      </div>

      <div class="flex flex-col" style="justify-content: space-around">
        @for (attr of renderedYAttributes; track attr) {
          <h6 style="font-size: 0.5rem; font-weight: 600">{{ attr }}</h6>
        }
      </div>

      <div class="text-neutral-600">
        <svg height="100%" preserveAspectRatio="none" viewBox="0 0 12 200" width="12">
          <line stroke="currentColor" stroke-width="1" x1="6" x2="6" y1="0" y2="200"/>
          <polygon fill="currentColor" points="6,0 2,2 10,2"/>
        </svg>
      </div>
    </td>
    <td class="w-full pl-3 pb-3 h-full">
      <div class="heatmap-matrix-wrap">
        <div class="flex flex-col gap-1 h-full">
          @for (row of renderedRows; track row.track) {
            <div [style.flex]="'calc(' + 1 / (attributes.y.length + 1) + '* 100%)'" class="flex flex-row gap-1">
              @for (val of row.cells; let j = $index; track 'col_' + j) {
                <div
                  [class.bg-green-300]="isGreenCell(row.logicalRowIndex, j)"
                  [class.bg-red-300]="isRedCell(row.logicalRowIndex, j)"
                  [class.bg-yellow-300]="isYellowCell(row.logicalRowIndex, j)"
                  [style.flex]="'calc(' + 1 / (attributes.x.length + 1) + '* 100%)'"
                  class="cursor-pointer rounded-[0.25rem]"></div>
              }
            </div>
          }
        </div>
        @if (renderedPoints.length) {
          <div class="heatmap-points-layer">
            @for (point of renderedPoints; track point.key) {
              <div
                [style.left.%]="point.left"
                [style.top.%]="point.top"
                class="heatmap-point">
                <span class="heatmap-point-badge">{{ point.badge }}</span>
                <div class="heatmap-point-tooltip">{{ point.tooltip }}</div>
              </div>
            }
          </div>
        }
      </div>
    </td>
  </tr>
  <tr>
    <td></td>
    <td>
      <div class="flex flex-col gap-2 w-full">
        <div class="text-neutral-600">
          <svg height="12" preserveAspectRatio="none" viewBox="0 0 200 12" width="100%">
            <line stroke="currentColor" stroke-width="1" x1="0" x2="200" y1="6" y2="6"/>
            <polygon fill="currentColor" points="200,6 198,2 198,10"/>
          </svg>
        </div>

        <div class="flex flex-row" style="justify-content: space-around">
          @for (attr of attributes.x; track attr) {
            <h6 style="font-size: 0.5rem; font-weight: 600">{{ attr }}</h6>
          }
        </div>

        <div class="label-x">
          @if (labels.x) {
            <h4>{{ labels.x }}</h4>
          }
        </div>
      </div>
    </td>
  </tr>
</table>
